class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    
    const closeButtons = this.querySelectorAll('button[type="button"], .search-drawer__close-btn, .modal__close-button');
    closeButtons.forEach((btn) => btn.addEventListener('click', () => this.close()));

    const modalOverlay = this.querySelector('.search-modal, .modal-overlay, .search-drawer');
    if (modalOverlay) {
      modalOverlay.addEventListener('click', (event) => {
        const inner = this.querySelector('.search-drawer__inner, .search-modal__content, .modal__content-inner');
        if (!inner || !inner.contains(event.target)) {
          this.close(false);
        }
      });
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    const isTargetOverlay =
      event.target.classList.contains('modal-overlay') ||
      event.target.classList.contains('search-modal') ||
      event.target.classList.contains('search-drawer');

    const drawerInner = this.querySelector('.search-drawer__inner, .search-modal__content, .modal__content-inner');
    const isClickOutsideInner = drawerInner && !drawerInner.contains(event.target) && !event.target.closest('summary');

    if (!this.contains(event.target) || isTargetOverlay || isClickOutsideInner) {
      this.close(false);
    }
  }

  open(event) {
    if (this.isClosing) return;
    this.classList.remove('is-closing');
    if (this.detailsContainer) this.detailsContainer.classList.remove('is-closing');

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
      document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
    }
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );

    const input = this.querySelector('input[type="search"]');
    if (input && typeof window.fetchPredictiveSearchResults === 'function') {
      window.fetchPredictiveSearchResults(input);
    }
  }

  close(focusToggle = true) {
    if (this.isClosing || !this.isOpen()) return;

    this.isClosing = true;
    this.classList.add('is-closing');
    if (this.detailsContainer) this.detailsContainer.classList.add('is-closing');

    setTimeout(() => {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
      if (this.detailsContainer) {
        this.detailsContainer.removeAttribute('open');
        this.detailsContainer.classList.remove('is-closing');
      }
      this.classList.remove('is-closing');
      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove('overflow-hidden');
      document.documentElement.style.setProperty('--scrollbar-width', '0px');
      this.isClosing = false;
    }, 450);
  }
}

customElements.define('details-modal', DetailsModal);
